import { createAction, props } from '@ngrx/store';
import { SnackBarConfig } from '../../shared/models/snack-bar-config.model';

export const showSnackBarAction = createAction(
    '[SnackBar] Show Snack-bar',
    props<{ config: SnackBarConfig }>(),
);

export const hideSnackBarAction = createAction('[SnackBar] Hide Snack-bar');
